import { Flex, Grid } from "@eworkit/iris";
import React, { FC } from "react";

import { PreviewFileEntry } from "@/components/Files/preview/PreviewFileEntry";
import { IAttachment } from "@/data/attachments";

interface AttachmentsSectionProps {
  attachments: IAttachment[];
}

export const AttachmentsGridPreview: FC<AttachmentsSectionProps> = ({ attachments }) => {
  return (
    <Flex flexDirection="column" gap="sm" py="md">
      <Grid columns={["1fr", null, null, "1fr 1fr"]}>
        {attachments.map(attachment => (
          <Grid key={attachment.systemId}>
            <PreviewFileEntry attachment={attachment}>{attachment.name}</PreviewFileEntry>
          </Grid>
        ))}
      </Grid>
    </Flex>
  );
};
